import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import StringHelper from "../../services/Common/StringHelper";
import {ConfigApi, MultistoreItemTitleType} from "../../services/Api/types";
import {ReactComponent as ArrowBottomSVG} from "../../../images/icons/arrow-bottom.svg";
import {Link} from "react-router-dom";

interface OwnProps {
    config: ConfigApi
    multistoreConfig?: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function NavbarPlaces(props: Props) {
    const sameAddressAsMultistore = JSON.stringify({
        city: props.config.address?.city,
        street: props.config.address?.street,
        build_nr: props.config.address?.build_nr,
        flat_nr: props.config.address?.flat_nr,
    }) === JSON.stringify({
        city: props.multistoreConfig?.address?.city,
        street: props.multistoreConfig?.address?.street,
        build_nr: props.multistoreConfig?.address?.build_nr,
        flat_nr: props.multistoreConfig?.address?.flat_nr,
    });
    const addressName = StringHelper.getAddressName(props.config.address);
    const multiStoreItemTitleType = props.multistoreConfig?.layout.multistore_item_title_type ?? MultistoreItemTitleType.BOTH;

    const getTitle = () => {
        if (multiStoreItemTitleType === MultistoreItemTitleType.BOTH) {
            return props.config.name;
        }

        return sameAddressAsMultistore ? props.config.name : addressName || props.config.name;
    }

    const getDescription = () => {
        if (multiStoreItemTitleType === MultistoreItemTitleType.BOTH) {
            return sameAddressAsMultistore ? undefined : addressName;
        }

        return undefined;
    }

    const description = getDescription();

    return (
        <>
            <Link to={"/map"} className={"btn btn-choose-place btn-flex btn-choose-place-with-logo"}>
                <div className={"multiline"}>
                    <h5>
                        {getTitle()}
                    </h5>
                    {description && (
                        <small>
                            {description}
                        </small>
                    )}
                </div>
                <ArrowBottomSVG/>
            </Link>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(NavbarPlaces));